var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save detail-mode",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c(
            "div",
            { staticClass: "wrap-screen-mode justify-content-between" },
            [
              _c("div", { staticClass: "screen-mode" }, [
                _c(
                  "div",
                  {
                    staticClass: "screen-list",
                    class: { selected: _vm.dataSetup.is_pagescreen },
                    on: {
                      click: function($event) {
                        _vm.dataSetup.is_pagescreen = true
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/new-form-ui/screen-mode/page-screen.svg")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "screen-list",
                    class: { selected: !_vm.dataSetup.is_pagescreen },
                    on: {
                      click: function($event) {
                        _vm.dataSetup.is_pagescreen = false
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/new-form-ui/screen-mode/modal-screen.svg")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "screen-text" }, [
                  _c("p", [_vm._v("VIEW MODE")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        (_vm.dataSetup.is_pagescreen ? "Page" : "Modal") +
                          " Screen"
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "save-button", on: { click: _vm.submitForm } },
                [_vm._v("\n        Save\n      ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-page card-page-detail",
          attrs: { id: "cardPage" }
        },
        [
          _c(
            "div",
            { staticClass: "icon-code-editor icon-code-editor--only" },
            [
              _c("img", {
                attrs: { src: require("@/assets/new-form-ui/code-editor.svg") },
                on: { click: _vm.openModalCodeEditor }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-component" }, [
                _vm._v("\n        Code Editor\n      ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-page-title",
              class: { "card-page-title--white": !_vm.dataSetup.is_pagescreen }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dataSetup.title,
                    expression: "dataSetup.title"
                  }
                ],
                staticClass: "input-title",
                class: { "error-input": _vm.$v.dataSetup.title.$error },
                attrs: { type: "text", placeholder: "Enter title here" },
                domProps: { value: _vm.dataSetup.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.dataSetup, "title", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-page-content" },
            [
              _c(
                "b-row",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: _vm.dataSetup.is_pagescreen ? 8 : 12 } },
                    [
                      _c(
                        "section",
                        {
                          staticClass: "section-field",
                          class: {
                            "have-data":
                              _vm.dataSetup.column &&
                              _vm.dataSetup.column.length > 0
                          }
                        },
                        [
                          _c("h5", [_vm._v("Fields")]),
                          _vm._v(" "),
                          _vm.isLoading ? _c("j-skeleton-field") : _vm._e(),
                          _vm._v(" "),
                          !_vm.isLoading
                            ? _c(
                                "draggable",
                                {
                                  staticClass: "wrap-field no-gutters",
                                  attrs: {
                                    options: {
                                      animation: 300,
                                      disabled: _vm.selectedIndexField,
                                      handle: ".icon-drag"
                                    },
                                    group: "fieldsLibrary"
                                  },
                                  on: { change: _vm.modifyData },
                                  model: {
                                    value: _vm.dataSetup.column,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataSetup, "column", $$v)
                                    },
                                    expression: "dataSetup.column"
                                  }
                                },
                                _vm._l(_vm.dataSetup.column, function(
                                  column,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: column.field_ui_key,
                                      class:
                                        "col-md-" +
                                        (column.grid_size
                                          ? column.grid_size
                                          : 12),
                                      staticStyle: { "padding-right": "10px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "field-list",
                                          class: {
                                            selected:
                                              index === _vm.selectedIndexField
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openPropertiesField(
                                                column,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "column-name" },
                                            [_vm._v(_vm._s(column.name))]
                                          ),
                                          _vm._v(" "),
                                          _c("field-preview", {
                                            attrs: { column: column }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "edit-or-delete" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "button" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "edit",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.openPropertiesField(
                                                            column,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-pencil-square-o"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "tooltip-component"
                                                        },
                                                        [_vm._v("Edit field")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.deleteField(index)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "tooltip-component"
                                                        },
                                                        [_vm._v("Delete field")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                })
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-add-more mt-3",
                              on: {
                                click: function($event) {
                                  _vm.openModalFieldLibrary(false)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "m__r--5",
                                attrs: {
                                  src: require("@/assets/icon/add.png"),
                                  height: "15",
                                  width: "15"
                                }
                              }),
                              _vm._v("\n              Add Fields\n            ")
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.dataSetup.is_pagescreen
                    ? _c("b-col", { attrs: { cols: "4" } }, [
                        _c(
                          "section",
                          [
                            _c("h5", [_vm._v("Action Button")]),
                            _vm._v(" "),
                            _vm.isLoading
                              ? _c("j-skeleton-action-button")
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isLoading
                              ? _c(
                                  "draggable",
                                  {
                                    model: {
                                      value: _vm.dataSetup.action_buttons,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "action_buttons",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.action_buttons"
                                    }
                                  },
                                  _vm._l(_vm.dataSetup.action_buttons, function(
                                    button,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "action-button-list",
                                        class: {
                                          selected:
                                            index === _vm.selectedIndexBtn
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.openConfigActionButton(
                                              button,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          class:
                                            "icon-button fa " +
                                            (button.icon_web.includes("fa-")
                                              ? button.icon_web
                                              : "fa-" + button.icon_web)
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(button.label) +
                                            "\n\n                "
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "edit-or-delete" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "button" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "edit",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.openConfigActionButton(
                                                          button,
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil-square-o"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "delete",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.deleteActionButton(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-more",
                                on: {
                                  click: function($event) {
                                    _vm.openConfigActionButton(null, null)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "m__r--5",
                                  attrs: {
                                    src: require("@/assets/icon/add.png"),
                                    height: "15",
                                    width: "15"
                                  }
                                }),
                                _vm._v(
                                  "\n              Add Button\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isWorkflow
                          ? _c("section", { staticClass: "m__t--15" }, [
                              _c("h5", [_vm._v("Record Activity")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "configuration-log-workflow" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "configuration-toggle-in-title"
                                    },
                                    [
                                      _c("div", { staticClass: "wrap-title" }, [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              "configuration-section-title"
                                          },
                                          [_vm._v("Hidden Log Workflow ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "configuration-section-desc"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    If the "
                                            ),
                                            _c("b", [
                                              _vm._v("Hidden Log Workflow")
                                            ]),
                                            _vm._v(" toggle is enabled, the "),
                                            _c("b", [_vm._v("Log Workflow")]),
                                            _vm._v(
                                              " in the record details will disappear.\n                  "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("j-switch", {
                                        model: {
                                          value:
                                            _vm.dataSetup
                                              .is_hidden_log_workflow,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup,
                                              "is_hidden_log_workflow",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dataSetup.is_hidden_log_workflow"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: _vm.dataSetup.is_pagescreen ? 8 : 12 } },
                    [
                      _c(
                        "section",
                        [
                          _c("h5", [_vm._v("Button")]),
                          _vm._v(" "),
                          _c("native-buttons", {
                            attrs: {
                              "data-buttons": _vm.nativeButtons,
                              "is-workflow": _vm.isWorkflow,
                              "is-dynamic-workflow": _vm.isDynamicWorkflow,
                              "is-approver-selection-by-function":
                                _vm.isApproverSelectionByFunction,
                              "is-page-screen": _vm.dataSetup.is_pagescreen,
                              "button-active": _vm.modeBtn,
                              menu: "detail"
                            },
                            on: { "select-btn": _vm.openConfigNativeButton }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-transparent card-transparent-detail m__t--15" },
        [
          _vm.formDetail.detail_view
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer",
                  staticStyle: { "font-size": "14px" },
                  on: {
                    click: function($event) {
                      _vm.deleteView("detail")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Delete this view")])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedField
        ? _c("properties-field", {
            ref: _vm.idPropertiesField,
            attrs: {
              id: [_vm.idPropertiesField],
              "field-detail": _vm.selectedField,
              "variable-options": _vm.variableOptions,
              "field-ui-key": _vm.dataSetup.column,
              "is-page-screen": _vm.dataSetup.is_pagescreen,
              "is-detail-view": true,
              "is-new-field": _vm.isNewField,
              "variable-options-watermark": _vm.variableOptionsWatermark,
              "native-buttons": _vm.nativeButtons
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.toggleProperties(false)
              },
              "submit-preview": _vm.submitPreview,
              "submit-mode": _vm.submitField,
              "open-modal-full-script": _vm.openModalFullScript,
              "open-modal-company-drive": _vm.openModalCompanyDrive
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigActionBtn
        ? _c("action-button-configuration", {
            attrs: {
              id: _vm.idConfigActionBtn,
              "field-detail": _vm.selectedBtn,
              "variable-options": _vm.variableOptions
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfigurationActionBtn(false)
              },
              "delete-action-button": _vm.deleteActionButton,
              "submit-configuration": _vm.submitActionButton
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigNativeBtn
        ? _c("native-button-configuration", {
            attrs: {
              id: _vm.idConfigNativeBtn,
              "field-detail": _vm.selectedNativeBtn,
              "is-revision-btn": _vm.isRevisionBtn,
              label: _vm.labelBtn,
              mode: _vm.modeBtn
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfigurationNativeBtn(false)
              },
              "submit-configuration": _vm.submitNativeButton
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalExternalApi",
          staticClass: "modal-external-api",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [_vm.showModalExternalUrl ? _c("modal-external-api-field") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm.showModalIconActionBtn
        ? _c("modal-icon-action-btn", {
            attrs: { id: _vm.idConfigIconActionBtn },
            on: {
              "select-icon": _vm.selectIconActionBtn,
              "close-modal": _vm.closeModalIconActionBtn
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalScriptActionBtn",
          staticClass: "modal-native-action-button",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalScriptActionBtn
            ? _c("modal-script-action-btn")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalScriptBeforeAfter",
          staticClass: "modal-native-action-button",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalScriptBeforeAfter
            ? _c("modal-script-before-after-field")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalFullScript",
          staticClass: "mod-full-block",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-fullscreen" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c("div", { staticClass: "label-log-detail" }, [
                    _vm._v("Script")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "pull-right cursor-pointer",
                    attrs: {
                      src: require("@/assets/icon/minimize.svg"),
                      alt: "fullscreen"
                    },
                    on: { click: _vm.minimizeBlock }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.openEditor
                ? _c("j-monaco-editor", {
                    ref: "scriptEditor",
                    attrs: { value: _vm.onValueChange }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-update-properties-automation",
                  on: { click: _vm.minimizeBlock }
                },
                [_vm._v("Update")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCodeEditor",
          staticClass: "modal-code-editor-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalCodeEditor
            ? _c("modal-code-editor", {
                attrs: {
                  "view-data": _vm.viewJsonData,
                  "view-title": "Detail View",
                  type: "detail_view"
                },
                on: {
                  close: _vm.closeModalCodeEditor,
                  update: _vm.updateViewByCode
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showModalCompanyDrive
        ? _c("modal-company-drive", {
            on: { "close-popup": _vm.handleCloseModalCompanyDrive }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-106573ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-106573ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jDetailView.vue
// module id = null
// module chunks = 